<!-- hide during setup -->
@if (!auth.currentUser() || accountService.currentCompanyCount()) {
  <div class="public-footer navy-bg hidden-xs">
    <div class="container">
      <div class="row">
        <!-- LINKS -->
        <div class="col-lg-8">
          <div class="flex-list footer-nav">
            <ul>
              <li>
                <a title="InfoDocs About" href="https://www.linkedin.com/company/InfoDocsZA/"> About </a>
              </li>
              <li>
                <a title="InfoDocs Blog" href="{{ blogUrl }}" target="_blank"> Blog </a>
              </li>
              <li>
                <a title="InfoDocs Help Centre" href="{{ helpCentreUrl }}" target="_blank"> Help Centre </a>
              </li>
            </ul>
          </div>
          <div class="copyright">
            <p>
              Copyright &copy; {{ currentYear }}. All rights reserved. Proudly South African
              <img class="flag" src="./assets/img/za-flag.png" alt="South Africa" />
            </p>
            <p>Info Docs (Pty) Ltd 2017/110492/07 Registered Office: 32 Kloof Street, Gardens, Cape Town, Western Cape, 8001</p>
          </div>
        </div>
        <!-- SOCIALS -->
        <div class="col-lg-4">
          <p>Follow our progress</p>
          <ul class="social-nav">
            <li>
              <a title="InfoDocs Facebook" href="https://facebook.com/InfoDocsZA">
                <app-icon [icon]="facebookIcon" />
              </a>
            </li>
            <li>
              <a title="InfoDocs Twitter" href="https://twitter.com/InfoDocsZA">
                <app-icon [icon]="xIcon" />
              </a>
            </li>
            <li>
              <a title="InfoDocs LinkedIn" href="https://linkedin.com/companies/InfoDocsZA">
                <app-icon [icon]="linkedInIcon" />
              </a>
            </li>
            <!-- <li><a href="https://medium.com/@InfoDocsZA"><i class="fab fa-medium-m"></i></i></a></li>
            <li><a href="https://plus.google.com/101810361890887933343"><i class="fab fa-google-plus-g"></i></i></a></li> -->
          </ul>
        </div>
      </div>
    </div>
  </div>
}
